import { Typography } from '@mui/material';
import ErrorIcon from '@mui/icons-material/Error';
import { Box } from '@mui/material';

export default function MahiErrorFallback() {

    return (
    <Box className="Page MahiErrorFallback">
        <Typography variant="h3"><ErrorIcon fontSize="large" /> Problem</Typography>
        <Typography variant="h5">Something went wrong when we tried to display your page.</Typography>
        <p>
            We're sorry and we have logged the error in our system.
        </p>
        <p>
            You might be able to use the menu options above to return to what you were doing.
        </p>
        <p>
            Otherwise please contact Mahi technical support at Northpower.
        </p>
    </Box>
    );
}